import { gql } from "@apollo/client";

export const loadCampaignById = gql`
  query LoadCampaignById($id: String) {
    loadCampaignById(id: $id) {
      id
      type
      title
      endless
      titleShort
      description
      position
      category
      sweepstakesCategory
      countries
      campaignStatus
      programId
      channels
      mediaCampaignId
      slug
      excludeFromListing
      campaignGroupId
      hasRewardUnlock
      brands
      publishingStatus
      approvalStatus
      displayStartDate
      displayEndDate
      archivedAt
      activeStartDate
      activeEndDate
      paused
      unlockedCatalogs
      lockedCatalogs
      leaderboardCatalogs
      segments
      excludeSegments
      groups
      tags
      rewardCategories
      hasShowEntriesCount
      hasShowInHistory
      displayAfterEndDate
      token
      catalogRefs {
        catalogId
        attachedAt
      }
      campaignRules {
        id
        ruleData
        ruleDefinition {
          id
          name
          hidden
          inputSchema
          ruleFunction
          maxAllowed
          slug
          uiSchema
        }
      }
      activities {
        id
        name
        description
        outcomes {
          outcomeDefinition {
            id
            name
            description
            inputSchema
            requiredRules
            slug
            uiSchema
            rules {
              id
              name
              hidden
              inputSchema
              ruleFunction
              maxAllowed
              slug
              uiSchema
            }
          }
          outcomeData
          outcomeRules {
            ruleData
            ruleDefinition {
              id
              name
              hidden
              inputSchema
              ruleFunction
              maxAllowed
              slug
              uiSchema
            }
          }
        }
        activityRules {
          ruleData
          ruleDefinition {
            id
            name
            hidden
            inputSchema
            ruleFunction
            maxAllowed
            slug
            uiSchema
          }
        }
        activityDefinition {
          id
          name
          description
          inputSchema
          requiredRules
          slug
          maxAllowed
          uiSchema
          customProperties
          rules {
            id
            name
            hidden
            inputSchema
            ruleFunction
            maxAllowed
            slug
            uiSchema
          }
          outcomes {
            id
            name
            description
            inputSchema
            requiredRules
            slug
            uiSchema
            rules {
              id
              name
              hidden
              inputSchema
              ruleFunction
              maxAllowed
              slug
              uiSchema
            }
          }
          requiredOutcomes
        }
        activityData
      }
      outcomes {
        id
        outcomeDefinition {
          name
          description
          inputSchema
          requiredRules
          slug
          uiSchema
          rules {
            name
            hidden
            inputSchema
            ruleFunction
            maxAllowed
            slug
            uiSchema
            id
          }
          id
        }
        outcomeData
        outcomeRules {
          ruleData
          ruleDefinition {
            id
            name
            hidden
            inputSchema
            ruleFunction
            maxAllowed
            slug
            uiSchema
          }
        }
      }
      campaignContent {
        id
        title
        slug
        segments
        description
        status
        activeStartDate
        activeEndDate
        contentData
        tags
        category
        createdAt
        updatedAt
        deletedAt
      }
      segmentedContents {
        segments
        contentData
      }
      relatedCampaigns
      hasParticipantStores
      uniqueSegmentedUsersCount
      deletedRewardGroups
    }
  }
`;
